import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const done = useRef(false);

    useEffect(() => {
        if (done.current) return;
        done.current = true;
        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        const session_id = m ? decodeURIComponent(m[1]) : null;

        (async () => {
            if (!session_id) { navigate("/", { replace: true }); return; }
            try {
                const { data } = await api.post("/auth/session", { session_id });
                setUser(data);
                window.history.replaceState(null, "", "/dashboard");
                const target = data.role === "admin" ? "/admin" : "/dashboard";
                navigate(target, { replace: true, state: { user: data } });
            } catch (e) {
                navigate("/", { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-obsidian text-ivory">
            <div className="text-center">
                <div className="font-mono-label mb-3">Signing you in</div>
                <div className="w-12 h-12 mx-auto rounded-full border-2 border-gold border-t-transparent animate-spin" />
            </div>
        </div>
    );
}
